
/**
 * @class
 * @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';

      if (window.localStorage) {
        const recentIds = window.localStorage.getItem('recently-viewed');

        if (recentIds) {
          try {
            window.recentlyViewedIds = JSON.parse(recentIds);
          } catch (e) {
            window.recentlyViewedIds = [];
          }
        }
      }
    }

    connectedCallback() {
      this.buildUrl();
    }

    buildUrl() {
      const recentIds = window.recentlyViewedIds || [];
      let count = 0;

      recentIds.forEach((handle) => {
        if (handle === this.currentId || count >= this.max) {
          return;
        }

        this.products += 'handle:' + handle + ' OR ';
        count++;
      });

      if (!this.products) {
        return;
      }

      this.url += encodeURIComponent(this.products);
      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;

            if (this.container.children.length) {
              this.classList.add('product-recommendations--loaded');
            }
          }
        })
        .catch((error) => {
          console.error('Recently viewed products could not be loaded:', error);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
